const citationFormsToggleButtons = document.querySelectorAll(".js-citation-form__citations-toggle");

citationFormsToggleButtons.forEach(citationFormToggleButton => {
  citationFormToggleButton.addEventListener("click", function() {
    const citationForm = this.closest(".js-citation-form");
    citationForm.classList.toggle("c-citation-form--open");
  });
});
